var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.394,
    height: 24.242,
    viewBox: "0 0 19.394 24.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.7,15.333A1.806,1.806,0,0,0,12.485,18.5v1.685a1.212,1.212,0,1,0,2.424,0V18.5A1.806,1.806,0,0,0,13.7,15.333Zm6.061-4.848V8.061a6.061,6.061,0,1,0-12.121,0v2.424A3.636,3.636,0,0,0,4,14.121v8.485a3.636,3.636,0,0,0,3.636,3.636H19.757a3.636,3.636,0,0,0,3.636-3.636V14.121A3.636,3.636,0,0,0,19.757,10.485Zm-9.7-2.424a3.636,3.636,0,1,1,7.273,0v2.424H10.061ZM20.97,22.606a1.212,1.212,0,0,1-1.212,1.212H7.636a1.212,1.212,0,0,1-1.212-1.212V14.121a1.212,1.212,0,0,1,1.212-1.212H19.757a1.212,1.212,0,0,1,1.212,1.212Z",
    transform: "translate(-4 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.a259dce52d52bb623e65120a2ac09ea9.svg";
export { ForwardRef as ReactComponent };